import { useTranslation } from 'react-i18next'

import { LinkButton, type LinkButtonProps } from '~/components/link-button'
import { useSettingsStore } from '~/stores/settings'
import { canDisplayInstallOnIos } from '~/utils/can-display-install-on-ios'

export const IOSInstallButton = ({ onClick }: Pick<LinkButtonProps, 'onClick'>) => {
  const { t } = useTranslation()
  const appWasInstalled = useSettingsStore(state => state.appWasInstalled)

  if (appWasInstalled || !canDisplayInstallOnIos()) return null

  return (
    <LinkButton onClick={onClick} to="/settings/ios-install" variant="secondary">
      {t('Install')}
    </LinkButton>
  )
}
